import React from 'react';
import './ClassroomEnhanced.css';

const MissionDeck = ({ missions = [], onComplete, userType }) => {
  const emptyState = !missions || missions.length === 0;

  return (
    <section className="mission-deck">
      <div className="section-heading">
        <div>
          <p className="eyebrow">Story quests</p>
          <h3>Today's classroom missions</h3>
        </div>
        {userType === 'coach' && (
          <span className="section-chip">Coach view</span>
        )}
      </div>

      {emptyState ? (
        <div className="mission-empty">
          <p>No missions yet. Ask your coach to drop a new quest! 🚀</p>
        </div>
      ) : (
        <div className="mission-grid">
          {missions.map((mission) => (
            <article key={mission.id} className={`mission-card ${mission.status === 'completed' ? 'completed' : ''}`}>
              <div className="mission-emoji" aria-hidden="true">{mission.emoji || '🎯'}</div>
              <div className="mission-body">
                <h4>{mission.title}</h4>
                <p>{mission.description}</p>
                <div className="mission-meta">
                  <span>Reward: ⭐ {mission.reward || 10}</span>
                  <span>Status: {mission.status || 'available'}</span>
                </div>
              </div>
              {mission.status !== 'completed' && (
                <button
                  type="button"
                  className="mission-complete-btn"
                  onClick={() => onComplete && onComplete(mission.id)}
                >
                  Mark as done
                </button>
              )}
              {mission.status === 'completed' && (
                <p className="mission-celebration">🎉 Completed by your squad!</p>
              )}
            </article>
          ))}
        </div>
      )}
    </section>
  );
};

export default MissionDeck;
